<template>
  <v-dialog v-model="$store.state.showWelcomeBack" max-width="500">
    <v-card class="pa-9 rounded-lg">
      <v-card-text class="text-center d-flex flex-column" style="gap: 40px">
        <div>
          <h3 class="mt-5 primary--text">Bem vindo de volta!</h3>
        </div>

        <div>
          <p>Você parou aqui: <br/> <strong>{{ currentRouteName }}</strong></p>
        </div>

        <NavButton
          name="Continuar"
          color="primary"
          @button-click="$store.commit('TOGGLE_WELCOME_BACK')"
        ></NavButton>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import NavButton from "@/components/NavButton.vue";

export default {
  components: {
    NavButton,
  },

  data() {
    return {
      dialog: false,
    };
  },

  computed: {
    currentRouteName() {
      return this.$route.name; // Acessa o nome da rota atual
    },
  },

};
</script>

<style scoped>
.v-dialog > .v-card > .v-card__text {
  padding: 0 !important;
}

h3 {
  font-size: 1.6rem;
}

p {
  font-size: 1.1rem;
}
</style>
